// extracted by mini-css-extract-plugin
export default {"resizeableWrapper":"resizeableWrapper-f7wAz","resizeable":"resizeable-e0nm3","hovered":"hovered-qGQBf"};